import { ReactNode } from "react"

interface ImageTextComponentProps {
  text: ReactNode
  images: string[]
  /**
   * If true, places images below the text (stacked vertically).
   * If false or undefined, places images side by side (text left, images right).
   */
  col?: boolean

  // Optional prop for a button or any other element under the text
  button?: ReactNode
}

function ImageTextComponent(props: ImageTextComponentProps) {
  const { text, images, col, button } = props

  // If col is true => flex-col => text above images
  // Otherwise => flex-row => text to the left, images to the right
  const containerClass = col
    ? "flex flex-col space-y-8"
    : "flex flex-row space-x-8"

  // If col = false, we give text a 'flex-3' region, images a 'flex-1' to share horizontal space
  // If col = true, no special sizing is applied, so images keep their original size below
  const textContainerClass = col ? "" : "flex-3"
  const imageContainerClass = col ? "" : "flex-1"

  return (
    <div className={containerClass}>
      {/* Text section + optional button */}
      <div className={`tracking-wide ${textContainerClass}`}>
        {text}
        {button && <div className="mt-4">{button}</div>}
      </div>

      {/* Each image in its own container */}
      {images.map((img) => (
        <div key={img} className={imageContainerClass}>
          <img className="rounded" src={img} alt="" />
        </div>
      ))}
    </div>
  )
}

export default ImageTextComponent
